module.exports = __webpack_public_path__ + "8fbc0184a9fca64107669fff64044895.svg";